import React, { useEffect, useState } from 'react';
import './Loader.css';

const Loader = ({ isLoading }) => {
  const [shouldRender, setShouldRender] = useState(isLoading);

  useEffect(() => {
    if (isLoading) {
        setShouldRender(true);
    } else {
        const timer = setTimeout(() => setShouldRender(false), 500);
        return () => clearTimeout(timer);
    }
  }, [isLoading]);

  if (!shouldRender) return null;

  return (
    <div className={`loader-container ${!isLoading ? 'fade-out' : ''}`}>
      <div className="loader-brand">
        <img src="/logo.webp" alt="Loading..." className="loader-logo" style={{ width: '80px', height: 'auto' }} fetchpriority="high" />
        <span className="loader-text">aurora<span className="dot">.</span>code</span>
      </div>
    </div>
  );
};

export default Loader;
